module.exports = __webpack_public_path__ + "img/avatar-maria.771fc3d5.jpg";